import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/nt/cms`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const ntApi = {
  getDashboardReason: (request) => {
    const { config } = request
    return instance().get('/dashboard/reason', config)
  }
}
export default ntApi



// WEBPACK FOOTER //
// ./src/api/nt.js